import { SectionPage } from "@/components/section-page";
import { Flex } from "@/base/components/index";
import { useBodyStyles } from "./body.styles";
import { BodyTable } from "./body-table";
import { BodySearch } from "./body-search";

export const Body = () => {
  const { styles } = useBodyStyles();

  return (
    <SectionPage
      classNames={{
        section: styles.section,
        body: styles.body,
      }}
    >
      <Flex vertical gap={24}>
        <BodySearch />
        <BodyTable />
      </Flex>
    </SectionPage>
  );
};
